import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import {
    PartnerTemplateCardCarousel,
    PartnerTemplateCarouselProps
} from "../../components/contentful-relay-components/partner-template-card-carousel-contentful-relay";

import {
    AdditionalCategoriesSection,
    AdditionalCategoriesSectionProps
} from "./additional-categories-section-contentful-relay";

const sectionStyles = css({
    position: "relative",
    padding: "32px 0px 0px 0px"
});

const textContentSection = css({
    backgroundImage:
        "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/partnerbackground.svg)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "bottom center",
    position: "relative",
    zIndex: 1
});

const headerStyles = css({
    "color": "#1C2B42",
    "paddingTop": "40px",
    "margin-bottom": "60px",
    "textAlign": "center",
    "lineHeight": "48px",
    "fontFamily": "var(--bxp-charlie-display-font-family)",
    "fontSize": "40px",
    "fontWeight": 700,
    "@media (max-width: 639.99px)": {
        width: "288px",
        margin: "0 auto 40px",
        fontSize: "1.5rem"
    },
    "@media (min-width: 640px) and (max-width: 767.99px)": {
        width: "592px",
        margin: "0 auto 40px"
    },
    "@media (min-width: 768px) and (max-width: 1023.99px)": {
        width: "592px",
        margin: "0 auto 40px"
    }
});

const partnerSectionStyles = css({
    padding: "0px 0px 112px px"
});

type TemplateLearnFromLeadersSectionProps = AdditionalCategoriesSectionProps &
    PartnerTemplateCarouselProps;

const TemplateLearnFromLeadersSection = ({
    templates,
    categories
}: TemplateLearnFromLeadersSectionProps) => {
    return (
        <section
            css={sectionStyles}
            data-testid="template-learn-from-leaders-section-relay"
        >
            <div css={textContentSection}>
                <h2 css={headerStyles}>
                    <FormattedMessage
                        id="confluence.templates.learn.from.industry.leaders"
                        defaultMessage="Learn from industry leaders"
                    />
                </h2>
                <div css={partnerSectionStyles}>
                    <PartnerTemplateCardCarousel templates={templates} />
                </div>
            </div>
            <AdditionalCategoriesSection categories={categories} />
        </section>
    );
};

TemplateLearnFromLeadersSection.displayName = "TemplateLearnFromLeadersSection";

export { TemplateLearnFromLeadersSection };
